import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { LeftLabel, RightLabel } from './atoms';


const template = styled.div`
    border-radius: 60px;
    cursor: pointer;
    display: flex;
    align-items: center;
    background: ${window?.settings?.primary_color ?? '#1DBD6B'};
    padding: 5px;
`;


export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: LeftLabel,
      name: 'LeftLabel',
      displayValue: ({ LeftBtnText }) => LeftBtnText || '',
      displayState: ({ state }) => ({ state }),
    },
    {
      component: RightLabel,
      name: 'RightLabel',
      displayValue: ({ RightBtnText }) => RightBtnText || '',
      displayState: ({ state }) => ({ state }),
    }
  ],
})